var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isShow)?_c('div',{staticClass:"v_all g-flex-align-center g-flex-justify-center"},[_c('div',{staticClass:"v-no-find"},[_c('div',{staticClass:"v-no-find-img"}),_c('p',{on:{"click":_vm.returnMainClick}},[_vm._v("返回首页")])])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }